const isProd = process.env.NODE_ENV === 'production'

// debug/info are no-ops in production — zero cost, eliminated by minifier
// warn/error always active — capture what the backend cannot see
export const log = {
  debug: isProd ? () => {} : console.debug.bind(console),
  info: isProd ? () => {} : console.info.bind(console),
  warn: (msg: string, ...args: unknown[]) => console.warn('[SRB]', msg, ...args),
  error: (msg: string, err?: unknown, ...args: unknown[]) =>
    console.error('[SRB]', msg, err ?? '', ...args),
}
